export default () => {
  const sendEvent = (eventName: string, data: unknown) => {
    const event = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(event);
  };

  const catchEvent = (eventName: string, eventFunction:(data: any) => typeof data, remove?: boolean) => {
    if (remove) {
      window.removeEventListener(eventName, eventFunction);
    } else {
      window.addEventListener(eventName, eventFunction);
    }
  };
  return { sendEvent, catchEvent };
};